import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import {
  Button,
  Dialog,
  TextField,
  MenuItem,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { NumberFormatCustom } from "../../ui-components";
import "cropperjs/dist/cropper.css";
import "./styles.css";

class BusquedaAvanzadaModal extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="busquedaAvanzada"
      >
        <DialogContent className="busquedaAvanzadaContent">
          <DialogContentText id="alert-dialog-description">
            {/* TITLE */}
            <Row>
              <Col xs={12} className="title">
                <div>Búsqueda avanzada</div>
              </Col>
            </Row>

            {/* SEPARADOR */}
            <Row>
              <Col xs={12} className="separador"></Col>
            </Row>

            {/* SEPARADOR */}
            <Row>
              <Col xs={6}>
                <TextField
                  className="filterInput"
                  select
                  label="Estado"
                  value={this.props.filtros.idEstadoPedido}
                  name="idEstadoPedido"
                  onChange={this.props.handleIdEstadoPedido}
                >
                  <MenuItem key={0} value={0}>
                    {"Todos los estados"}
                  </MenuItem>

                  {this.props.estadosPedido.map((e) => (
                    <MenuItem key={e.idEstadoPedido} value={e.idEstadoPedido}>
                      {e.descripcion}
                    </MenuItem>
                  ))}
                </TextField>
              </Col>

              <Col xs={6}>
                <TextField
                  className="filterInput"
                  name="numeroPedido"
                  label="Nro. pedido"
                  type="number"
                  onChange={this.props.handleNroPedido}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={6}>
                <TextField
                  className="filterInput"
                  name="idArticulo"
                  label="Codigo artículo"
                  onChange={this.props.handleCodigoArticulo}
                />
              </Col>

              <Col xs={6}>
                <TextField
                  className="filterInput"
                  name="numeroPedido"
                  label="Nombre artículo"
                  onChange={this.props.handleNombreArticulo}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={6}>
                <TextField
                  className="filterInput"
                  name="fechaHasta"
                  type="date"
                  label="Fecha Desde"
                  InputLabelProps={{ shrink: true }}
                  onChange={this.props.handleFechaDesde}
                />
              </Col>

              <Col xs={6}>
                <TextField
                  className="filterInput"
                  name="fechaHasta"
                  type="date"
                  label="Fecha Hasta"
                  InputLabelProps={{ shrink: true }}
                  onChange={this.props.handleFechaHasta}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={6}>
                <TextField
                  className="filterInput"
                  name="importeDesde"
                  label={this.props.filtros.importeHasta ? "Importe Desde" : "Importe"}
                  value={this.props.filtros.importeDesde}
                  onChange={this.props.handleOnChangeFiltroImporte}
                  InputProps={{ inputComponent: NumberFormatCustom }}
                />
              </Col>

              <Col xs={6}>
                <TextField
                  className="filterInput"
                  name="importeHasta"
                  label="Importe Hasta"
                  value={this.props.filtros.importeHasta}
                  onChange={this.props.handleOnChangeFiltroImporte}
                  InputProps={{ inputComponent: NumberFormatCustom }}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <TextField
                  className="filterInput"
                  name="idArticulo"
                  label="Razón social"
                  onChange={this.props.handleRazonSocial}
                />
              </Col>
            </Row>
          </DialogContentText>
        </DialogContent>

        <DialogActions className="margenInferior" id="ecommerce">
          <Button
            onClick={() => {
              this.props.handleOnVolver();
            }}
            className="btnSecundario"
          >
            VOLVER
          </Button>
          <Button
            onClick={() => {
              this.props.handleOnBuscarAvanzada(true);
            }}
            className="btnPrincipal"
          >
            BUSCAR
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

BusquedaAvanzadaModal.propTypes = {
  handleOnVolver: PropTypes.func,
  handleOnBuscarAvanzada: PropTypes.func,
  open: PropTypes.object,

  handleOnFiltroChange: PropTypes.func,
  estadosPedido: PropTypes.array.isRequired,
  filtros: PropTypes.object,

  handleFechaDesde: PropTypes.func,
  handleFechaHasta: PropTypes.func,
  handleNombreArticulo: PropTypes.func,
  handleCodigoArticulo: PropTypes.func,
  handleIdEstadoPedido: PropTypes.func,
  handleNroPedido: PropTypes.func,
  handleOnChangeFiltroImporte: PropTypes.func,
  handleRazonSocial: PropTypes.func,
};

BusquedaAvanzadaModal.defaultProps = {
  handleOnClose: (f) => f,
};

export default BusquedaAvanzadaModal;
